import styled from 'styled-components';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';

export const FieldWrapper = styled.div`
  margin-bottom: 20px;
`;

export const ConversationFormWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding-bottom: 40px;
  width: 700px;
`;

export const Separator = styled(HorizontalSeparator)`
  margin-bottom: 20px;
`;
